import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import updateTooltipPosition from '../__utils/tooltipHelpers';

import './style.scss';

export default class Tooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipPosition: this.props.position,
      containerPositionTop: 0,
      containerPositionLeft: 0,
    };

    this.tooltipRef = null;

    this.setTooltipRef = element => {
      this.tooltipRef = element;
    };

    this.setContainerRef = element => {
      this.containerRef = element;
    };
  }

  componentDidMount() {
    this.updatePosition(this.props.position);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.position !== this.state.tooltipPosition) {
      this.updatePosition(nextProps.position);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.state.displayTimeout);
    clearTimeout(this.state.delayTimeout);
  }

  updatePosition = newPosition => {
    const container = this.containerRef;
    const containerRect = container.getBoundingClientRect();
    const position = updateTooltipPosition(
      this.props.parent,
      container,
      this.tooltipRef,
      newPosition,
      this.props.maxWidth
    );
    this.setState({
      tooltipPosition: position,
      containerPositionTop: containerRect.top,
      containerPositionLeft: containerRect.left,
    });
  };

  delayShowTooltip = () => {
    if (this.props.delayTime) {
      this.setState({
        delayTimeout: setTimeout(() => {
          this.showTooltip();
        }, this.props.delayTime),
      });
    } else {
      this.showTooltip();
    }
  };

  showTooltip = () => {
    this.updatePosition(this.state.tooltipPosition);
    this.tooltipRef.classList.add('uni-tooltip--is-shown');

    // Dumb hack so that the animation works since is-shown changes the display css
    setTimeout(() => {
      this.tooltipRef.classList.add('uni-tooltip--animate');
    }, 0);
  };

  hideTooltip = () => {
    // if the timeout was set, clear it so that subsequent
    // mouse enters show the tooltip
    clearTimeout(this.state.delayTimeout);

    this.tooltipRef.classList.remove('uni-tooltip--is-shown', 'uni-tooltip--animate');
  };

  render() {
    const { children, text, maxWidth, qaId } = this.props;
    const { tooltipPosition } = this.state;
    const tooltipClasses = classnames('uni-tooltip', {
      [`uni-tooltip--${tooltipPosition}`]: tooltipPosition,
    });

    return (
      <div
        className="uni-tooltip__container"
        onMouseEnter={this.delayShowTooltip}
        onMouseLeave={this.hideTooltip}
        ref={this.setContainerRef}
        data-qa-id={qaId}
      >
        {children}
        <div className={tooltipClasses} style={{ maxWidth: maxWidth }} ref={this.setTooltipRef}>
          {text}
        </div>
      </div>
    );
  }
}

Tooltip.propTypes = {
  children: PropTypes.node,
  parent: PropTypes.string,
  delayTime: PropTypes.number,
  position: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
  text: PropTypes.node.isRequired,
  maxWidth: PropTypes.string,
  qaId: PropTypes.string,
};

Tooltip.defaultProps = {
  delayTime: 0,
  position: 'top',
};



// WEBPACK FOOTER //
// ./src/tooltip/index.jsx